// @ts-nocheck

import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { createSelector } from 'reselect';

import useMergeProps from '../../../hooks/useMergeProps';
import { selectEntitiesMatchesEntitySportId } from '../../../selectors/entities/matches/entitiesMatchesPrimary.selector';
import { selectIsMatchLive } from '../../../selectors/match.selector';
import { SportIds } from '../../../types/sports';
import { MatchCardAnimation } from '../components';

/* import RugbyRedCardAnimationContainer from './RugbyRedCardAnimationContainer'; */
import IceHockeyGoalAnimationContainer from './IceHockeyGoalAnimationContainer';
import RugbyTryAnimationContainer from './RugbyTryAnimationContainer';
import SoccerGoalAnimationContainer from './SoccerGoalAnimationContainer';

const getAnimations = ({ matchId, sportId }: { matchId: number; sportId?: number }) =>
  function ConditionalAnimation(props) {
    if (sportId === SportIds.SOCCER) {
      return (
        <>
          <SoccerGoalAnimationContainer matchId={matchId} {...props} />
        </>
      );
    }

    if (~[SportIds.RUGBY_LEAGUE, SportIds.RUGBY].indexOf(sportId)) {
      const scoreDifferenceTriggerThresholdMap = {
        [SportIds.RUGBY_LEAGUE]: 4,
        [SportIds.RUGBY]: 5,
      };
      const scoreDifferenceTriggerThreshold = sportId ? scoreDifferenceTriggerThresholdMap[sportId] : null;

      return (
        <>
          <RugbyTryAnimationContainer
            matchId={matchId}
            scoreDifferenceTriggerThreshold={scoreDifferenceTriggerThreshold}
            {...props}
          />
          {/* <RugbyRedCardAnimationContainer matchId={matchId} {...props} /> */}
        </>
      );
    }

    if (sportId === SportIds.ICEHOCKEY) {
      return <IceHockeyGoalAnimationContainer matchId={matchId} {...props} />;
    }
  };

const selectIsVisible = createSelector(
  [selectEntitiesMatchesEntitySportId, selectIsMatchLive],
  (sportId, isLive) =>
    isLive && !!~[SportIds.SOCCER, SportIds.RUGBY_LEAGUE, SportIds.RUGBY, SportIds.ICEHOCKEY].indexOf(sportId),
);

type MatchCardAnimationContainerProps = {
  matchId: number;
};

const MatchCardAnimationContainer = ({ matchId }: MatchCardAnimationContainerProps) => {
  const selectorProps = useMemo(() => ({ matchId }), [matchId]);
  const isVisible = useSelector((state) => selectIsVisible(state, selectorProps));
  const selectMatchSportId = useMemo(() => selectEntitiesMatchesEntitySportId, []);
  const sportId = useSelector((state) => selectMatchSportId(state, selectorProps));

  const Animations = useMemo(() => getAnimations({ matchId, sportId }), [matchId, sportId]);

  const otherProps = useMemo(() => ({ Animations }), [Animations]);

  const enhancedProps = useMergeProps({ otherProps });

  return isVisible ? <MatchCardAnimation {...enhancedProps} /> : null;
};

export default MatchCardAnimationContainer;
